import useAvailableDates from 'modules/experience/hooks/useAvailableDates';
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
} from 'react';

import reducer, { initialState } from './reducer';
import actionsFactory from './reducer/actions';

const initialContext = {
  ...initialState,
  expAvailabilityActions: actionsFactory(() => {}),
};

const ExperienceAvailabilityContext = createContext(initialContext);
const useExperienceAvailabilityContext = () =>
  useContext(ExperienceAvailabilityContext);

function ExperienceAvailabilityContextProvider({ experienceId, children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { data: availableDates, isFetched } = useAvailableDates(experienceId);
  const expAvailabilityActions = useMemo(
    () => actionsFactory(dispatch),
    [dispatch],
  );

  const contextValue = { ...state, expAvailabilityActions };

  useEffect(() => {
    if (experienceId && isFetched) {
      expAvailabilityActions.setAvailableDays(availableDates?.availability);
    }
  }, [experienceId, isFetched, availableDates, expAvailabilityActions]);

  return (
    <ExperienceAvailabilityContext.Provider value={contextValue}>
      {children}
    </ExperienceAvailabilityContext.Provider>
  );
}

export {
  useExperienceAvailabilityContext,
  ExperienceAvailabilityContextProvider,
};
